import { render, staticRenderFns } from "./ReportAff.vue?vue&type=template&id=ccbe1498"
import script from "./ReportAff.vue?vue&type=script&lang=js"
export * from "./ReportAff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports